import React, { useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { Redirect } from 'react-router-dom';
import * as CryptoJS from 'crypto-js';
import { Helmet } from "react-helmet";
import format from 'date-fns/format';

function Auth( { match } ) {
    const [redir, setRedir] = useState("");
	const [allKdData, setAllKdData] = useState({});
	const [cookies, setCookie] = useCookies(['user']);
	useEffect(() => {
		setAuth();
	}, []);
	localStorage.removeItem("chat_users");
    const setAuth = async () => {
		let param = match.params.enc
		//console.log(param)
		let enc_string = decodeURIComponent(param)
		//console.log(enc_string)
		let secret = process.env.REACT_APP_ENC_SECRET
		// New code starts
		let iv = CryptoJS.enc.Utf8.parse('0000000000000000');
		let key = CryptoJS.SHA256(secret);
		let dataStr = "error";
		let decrypted = CryptoJS.AES.decrypt(enc_string, key, {
			iv: iv,
			padding: CryptoJS.pad.Pkcs7,
			mode: CryptoJS.mode.CBC
		});
		// function timeout(delay) {
		// 	return new Promise( res => setTimeout(res, delay) );
		// }
		// await timeout(100000);
		//   console.log("hi");
		if (decrypted) {
			try {
				const decrtstr = decrypted.toString(CryptoJS.enc.Utf8);
				if (decrtstr.length > 0) {
					dataStr = decrtstr;
				} 
			} catch (e) {
				dataStr = 'error';
			}
		}
		//console.log(dataStr);
		// New code ends
		let user_id;
		let token;
		let user_type;
		let decryptData;
		let type;
		if (dataStr !== "error") {
			decryptData = dataStr.split("::");
			console.log(decryptData.length)
			console.log(decryptData)
			if (decryptData.length > 0) {
				user_id = decryptData[0];
				token = decryptData[1];
				user_type = decryptData[2];
				type = decryptData[3];
			}
		}
		console.log(user_id)
		if (user_id === undefined){
			console.log("error");
			//console.log(cookies.user_id);
			user_id = cookies.user_id;
			if(user_id === undefined){
				setRedir("error");
                localStorage.setItem("isAuthenticated", "false");
			}
		} else if (token === undefined){
			console.log("error2");
			//console.log(cookies.token);
			token = cookies.token;
			if(token === undefined){
				setRedir("error");
                localStorage.setItem("isAuthenticated", "false");
			}
		} else if(user_type === undefined){
			user_type = cookies.user_type;
			if(user_type === undefined){
				setRedir("error");
                localStorage.setItem("isAuthenticated", "false");
			}
		} else {
			// console.log("ok");
			if(user_type === "distributor"){
				const requestOptions = {
					method: 'POST',
					headers: { 'Content-Type': 'application/json','token':token, 'userId':user_id },
					body: JSON.stringify({user_id:user_id}),
					
				};
				const response	 = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'is-onboarded', requestOptions);
		
				const data = await response.json();

				if (data.status === "success") {
					localStorage.setItem("isAuthenticated", "true");
					localStorage.setItem("kdMsg", data.show_kingdom_message);
					const current = new Date();
					const nextYear = new Date();
					nextYear.setFullYear(current.getFullYear() + 1);
					setCookie('user_id', user_id, { path: '/', expires: nextYear });
					setCookie('token', token, { path: '/', expires: nextYear });
					localStorage.setItem('user_type', user_type);
					let impact_warrior = data.impact_warrior;
					let impact_warrior_date = data.impact_warrior_time;
					let is_onboarded = data.is_onboarded;
					localStorage.setItem("updateOnB", "0");
					if(type === 'bor'){
						setRedir("bor");
					} else {
						if(impact_warrior == "true" && is_onboarded != "true"){
							setRedir("welcome-iw");
							localStorage.setItem("iwtime", impact_warrior_date);
							localStorage.setItem("kdname", data.name);
						} else if(impact_warrior == "true"){
							localStorage.setItem("noSk", "1");
							setRedir("iw-home");
						} else {
							setRedir("home");
						}
					}
				} else {
					setRedir("error");
					localStorage.setItem("isAuthenticated", "false");
				}
			} else if(user_type === "retailer"){
				const requestOptions = {
					method: 'POST',
					headers: { 'Content-Type': 'application/json','token':token, 'userId':user_id },
					body: JSON.stringify({ret_user_id:user_id}),
					
				};
				const response = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-dist-uid-from-ret-uid', requestOptions);
		
				const data = await response.json();
				console.log(data);
				if (data.status === "success" && data.dist_user_id !== ""){
					localStorage.setItem("isAuthenticated", "true");
					const current = new Date();
					const nextYear = new Date();
					nextYear.setFullYear(current.getFullYear() + 1);
					setCookie('user_id', data.dist_user_id, { path: '/', expires: nextYear });
					setCookie('token', token, { path: '/', expires: nextYear });
					localStorage.setItem('user_type', user_type);
					// setRedir("allKingdom");
					console.log(type);
					setRedir("bor");

				} else {
					setRedir("error");
					localStorage.setItem("isAuthenticated", "false");
				}	
			} else {
				const requestOptions = {
					method: 'POST',
					headers: { 'Content-Type': 'application/json','token':token, 'userId':user_id },
					body: JSON.stringify({user_id:user_id}),
					
				};
				const response = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'user-id-validity', requestOptions);

				const data = await response.json();
				console.log(data);
				if (data.status === "success"){
					setAllKdData(data);
					localStorage.setItem("isAuthenticated", "true");
					const current = new Date();
					const nextYear = new Date();
					nextYear.setFullYear(current.getFullYear() + 1);
					setCookie('user_id', user_id, { path: '/', expires: nextYear });
					setCookie('token', token, { path: '/', expires: nextYear });
					localStorage.setItem('user_type', user_type);
					if(type === 'bor'){
						setRedir("allKingdom");
					} else {
						setRedir("rmborLeaderboard");
					}
				} else {
					setRedir("error");
					localStorage.setItem("isAuthenticated", "false");
				}	
			}

		}
	};


  return (
	  <>
		<Helmet link={
			[{"rel": "stylesheet", "href": '/css/faq.css'}]
		}/>	
	  	<nav>
			{ redir === "error" && (
				<div>
					<Redirect to='/'  />
				</div>
			)
			}
			{ redir === "home" && (
				<div>
					{/* <Redirect to={{
								pathname: '/distributor-home',
								state: data
							}}
					/> */}
					<Redirect to='/distributor-home'  />
				</div>
			)
			}
			{ redir === "bor" && (
				<div>
					<Redirect to='/region-home'  />
				</div>
			)
			}
			{ redir === "welcome-iw" && (
				<div>
					<Redirect to='/welcome-iw'  />
				</div>
			)
			}
			{ redir === "iw-home" && (
				<div>
					<Redirect to='/iw-home'  />
				</div>
			)
			}
			{ redir === "onboard" && (
				<div>
					<Redirect to='/welcome'  />
				</div>
			)
			}
			{ redir === "allKingdom" && (
				<div>
					<Redirect to="/all-kingdom"/>
				</div>
			)
			}
			{ redir === "rmborLeaderboard" && (
				<div>
					<Redirect to="/rms-leaderboard"/>
				</div>
			)
			}
			{ redir === "borLeaderboard" && (
				<div>
					<Redirect to="/distributor-leaderboard"/>
				</div>
			)
			}
			{ redir === "" && (
				<div className="row no-gutters">
				<div className="application bg-grey loading">
				{/* <div className="loading" id="loading">
                	<img alt="" src={require("./../images/sword.gif").default} className="img-fluid" />
				</div> */}
				</div>
				<div className="bg"></div>
			</div>
			)
			}
    	</nav>
		</>
  );
}

export default Auth;
